<template>
  <header class="header" :class="{ 'header--scrolled': scrolled }">
    <div class="container header__inner">
      <router-link to="/" class="header__logo">
        <img src="/img/icons/logo.png" alt="CandB.pro" class="header__logo-img" />
        <span>CandB.pro</span>
      </router-link>

      <nav class="header__nav" :class="{ 'header__nav--open': menuOpen }">
        <router-link to="/" class="header__link" @click.native="menuOpen = false">Главная</router-link>
        <router-link to="/features" class="header__link" @click.native="menuOpen = false">Возможности</router-link>
        <router-link to="/pricing" class="header__link" @click.native="menuOpen = false">Тарифы</router-link>
        <router-link to="/docs" class="header__link" @click.native="menuOpen = false">Документация</router-link>
        <router-link to="/contacts" class="header__link" @click.native="menuOpen = false">Контакты</router-link>
      </nav>

      <div class="header__actions">
        <base-button to="/demo" size="md">Демо-доступ</base-button>
        <button class="header__burger" @click="menuOpen = !menuOpen" :class="{ open: menuOpen }">
          <span /><span /><span />
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import BaseButton from '../ui/BaseButton.vue'
export default {
  name: 'SiteHeader',
  components: { BaseButton },
  data() {
    return { scrolled: false, menuOpen: false }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() { this.scrolled = window.scrollY > 20 },
  },
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  background: rgba(255,255,255,0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid transparent;
  transition: var(--transition);
}
.header--scrolled {
  border-color: var(--border);
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
}
.header__inner {
  display: flex;
  align-items: center;
  gap: 40px;
  height: 72px;
}
.header__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--dark);
  text-decoration: none;
}
.header__logo-img {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: contain;
}
.header__nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}
.header__link {
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  color: var(--gray);
  font-size: 0.9375rem;
  font-weight: 500;
  transition: var(--transition);
  text-decoration: none;
}
.header__link:hover,
.header__link.router-link-exact-active {
  color: var(--primary);
  background: var(--primary-light);
}
.header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}
.header__burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}
.header__burger span {
  display: block;
  width: 22px; height: 2px;
  background: var(--dark);
  border-radius: 2px;
  transition: var(--transition);
}

@media (max-width: 900px) {
  .header__nav {
    display: none;
    position: absolute;
    top: 72px; left: 0; right: 0;
    background: white;
    flex-direction: column;
    padding: 16px 24px 24px;
    border-bottom: 1px solid var(--border);
    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
    gap: 4px;
  }
  .header__nav--open { display: flex; }
  .header__link { width: 100%; }
  .header__burger { display: flex; }
}
</style>
